import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ProductInfoBase } from "abweb/dto/generated/product/ProductInfoBase";
import { ProductInfoItem } from "abweb/dto/product/ProductInfoItem";
export class ProductInfo extends ProductInfoBase {
  static createProductInfo(allowGuestAccess, buildID, date, helpModule, items, name, productVersion, usesUserAuthentication, version) {
    const retVal = new ProductInfo();
    retVal.initProductInfo(allowGuestAccess, buildID, date, helpModule, items, name, productVersion, usesUserAuthentication, version);
    return retVal;
  }
  static createEmptyProductInfo() {
    return ProductInfo.createProductInfo(/*allowGuestAccess*/true, /*buildID*/"", /*date*/"", /*helpModule*/null, /*items*/null, /*name*/"Ab Initio", /*productVersion*/null, /*usesUserAuthentication*/false, /*version*/"");
  }
  constructor() {
    super();
    _defineProperty(this, "_clientProductInfo", null);
    _defineProperty(this, "_officialName", undefined);
    _defineProperty(this, "productCapabilities", new Set());
  }
  getItem(name) {
    if (this.items == null) {
      return null;
    }
    let item;
    for (item of this.items) {
      if (item.name === name) {
        return item;
      }
    }
    return null;
  }
  toString() {
    return Object.keys(this).map(key => key + ":" + JSON.stringify(this[key], undefined, 2)).join("\n");
  }
  setClientProductInfo(clientProductInfo) {
    this._clientProductInfo = clientProductInfo;
  }
  getClientProductInfo() {
    return this._clientProductInfo;
  }
  getField(field) {
    return this._clientProductInfo?.[field] ?? super[field];
  }
  get allowGuestAccess() {
    return this.getField("allowGuestAccess");
  }
  get buildID() {
    return this.getField("buildID");
  }
  get date() {
    return this.getField("date");
  }
  get helpModule() {
    return this.getField("helpModule");
  }
  get items() {
    const serverItems = super["items"];
    // do we have any client items?
    if (this._clientProductInfo?.["items"]) {
      let temp = this._clientProductInfo["items"].slice();
      if (serverItems) {
        // add the server items, but rename existing items if there's an overlap
        serverItems.forEach(item => {
          if (temp.findIndex(x => item.name === x.name) >= 0) {
            // TODO: What about i18n?  item name is "Build ID", but display name is AbReactResources.about_dialog_buildId()?
            temp.push(ProductInfoItem.createProductInfoItem("Server " + item.name, item.value));
          } else temp.push(item);
        });
      }
      return temp;
    } else return serverItems;
  }
  get name() {
    return this.getField("name");
  }
  get officialName() {
    return this._officialName ?? this.name;
  }
  set officialName(officialName) {
    this._officialName = officialName;
  }
  get productVersion() {
    return this.getField("productVersion");
  }
  get usesUserAuthentication() {
    return this.getField("usesUserAuthentication");
  }
  get version() {
    return this.getField("version");
  }

  /**
   * Get value for "version", ignoring any client overrides
   * */
  get serverVersion() {
    return super.version;
  }

  /**
   * Returns true if the product supports the specified capability.
   */
  hasCapability(capability) {
    return this.productCapabilities.has(capability);
  }

  /**
   * Register a product capability as being supported.
   */
  registerCapability(capability) {
    this.productCapabilities.add(capability);
  }
}
_defineProperty(ProductInfo, "CUSTOM_SPLASH_DIALOG_INFO", "customSplashDialog");
//# sourceMappingURL=ProductInfo.js.map
